import React, { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/auth/auth.ts";
import { LoadingPage } from "@/uiKit/pages/LoadingPage.tsx";
import { Login } from "@/uiKit/pages/Login.tsx";

export const LoginBouncer = ({ children }: React.PropsWithChildren) => {
  const status = useAuth().status;
  const queryClient = useQueryClient();

  useEffect(() => {
    // Clear here rather than in the logout mutation: by the time this effect
    // runs the authenticated subtree is unmounted, so no query observer can
    // refetch against the destroyed axios instance. Without it, the next
    // patient on this tab would be served the previous one's cached data
    // (the query client keeps data for 5 min and never garbage collects).
    if (status === "unauthenticated") {
      queryClient.clear();
    }
  }, [status, queryClient]);

  if (status === "authenticated") {
    return children;
  }
  if (status === "unauthenticated") {
    return <Login />;
  }
  return <LoadingPage />;
};
